import Vue from "vue";

import buttonIncluirComponent from "@/components/child/form/button/buttonIncluir.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import ShortcutComponent from "@/components/parent/shortcut/shortcut";
import shortcutComponent from "@/components/parent/shortcut/shortcut.vue";
import { Component, Prop } from "@/decorators";
import RecompensaModel from "@/models/programafidelidade/recompensaModel";
import campanhaService from "@/services/campanhaService";
import PDFService from "@/services/pdf/PDFService";
import RecompensaService from "@/services/recompensaService";

import "../crud.scss";

const recompensaService = new RecompensaService();

@Component({
    components: {
        fieldsetComponent,
        gridComponent,
        buttonIncluirComponent,
        shortcutComponent,
    },
})
export default class ResgatarPontosComponent extends Vue {
    private shortcutComponent: ShortcutComponent = null;
    private pdfService = new PDFService("RecompensaPDF");

    campanhaId = 0;
    private gridData = [];

    @Prop({ type: Number, required: true }) clienteId: number;

    private get gridColumn(): Array<GridColumn> {
        return [
            new GridColumn("produtoDescricao", this.$t("__.ts.produto"), GridColumnType.String),
            new GridColumn("pontosNecessarios", this.$t("__.ts.pontosNecess"), GridColumnType.Integer),
            new GridColumn("quantidadeEstoque", this.$t("__.ts.qtdeEstoque"), GridColumnType.Decimal),
        ];
    }

    public async load(campanhaId: number) {
        this.gridData = await campanhaService
            .listRecompensas(campanhaId)
            .withLoading()
            .resolveWithJSON<RecompensaModel[]>();

        this.campanhaId = campanhaId;

        if (this.gridData.length === 0) {
            return await this.$showWarning(this.$t("__.ts.atencao"), this.$t("__.ts.nenhumaRecompensa"));
        }

        this.shortcutComponent = this.$refs.shortcutComponent as ShortcutComponent;
        this.shortcutComponent.title = this.$t("__.ts.resgatarPontos") as string;
        this.shortcutComponent.show();
    }

    private async onSelectRecompensa(data) {
        const response = await this.$showQuestion(this.$t("__.ts.atencao"), this.$t("__.ts.processResgate"));
        if (response) {
            const campanhaRecompensaResgateId = await recompensaService
                .resgatarRecompensaByCampanha(this.clienteId, this.campanhaId, data.id)
                .withLoading()
                .resolveWithJSON<number>();

            if (campanhaRecompensaResgateId > 0) {
                await this.$showSuccess(this.$t("__.ts.sucesso"), this.$t("__.ts.recompensaResgatada"));
                const imprimirResgateRecompensa = await this.$showQuestion(
                    this.$t("__.ts.atencao"),
                    this.$t("__.ts.imprimirRomaneioResgate"),
                );
                if (imprimirResgateRecompensa) {
                    await this.pdfService.geraPDF(campanhaRecompensaResgateId);
                }
            }
        }

        this.$emit("onResgateOk");
        this.shortcutComponent.hide();
    }
}
